// @flow
import { ErrorPage } from "@nested/brand";
import { useState } from "react";
import { useHistory } from "react-router-dom";
import { getConfig } from "@nested/config";
import { Sentry } from "@nested/isomorphic-sentry";
import { MultiStageForm, Question } from "../components/MultiStageForm";
import { CustomerIntent, Name, PhoneNumber, Source } from "../questions";
import { ManualOnboardingAddress } from "../questions/ManualOnboardingAddress";
import { ManualOnboardingEmail } from "../questions/ManualOnboardingEmail";

export const ManualAddressForm = () => {
  const history = useHistory();
  const [showOnSubmitError, setOnSubmitError] = useState(false);
  const { MANUAL_ONBOARDING_FORM_CLOUD_FUNCTION_URL } = getConfig();
  const onSubmit = async (state) => {
    try {
      const response = await fetch(MANUAL_ONBOARDING_FORM_CLOUD_FUNCTION_URL, {
        method: "POST",
        body: JSON.stringify(state),
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        throw new Error("Response not OK");
      }
      history.push("/get-started/onboarding/thank-you");
    } catch (error) {
      Sentry.captureException(error);
      setOnSubmitError(true);
    }
  };

  if (showOnSubmitError) {
    return <ErrorPage refreshPath="/" />;
  }

  const errorMessage = null;
  const setErrorMessage = () => {};

  return (
    <>
      <MultiStageForm
        onSubmit={onSubmit}
        submitError={errorMessage}
        setSubmitError={setErrorMessage}
        formType="personal-information"
        restartPath="/get-started/onboarding"
        lastButtonLabel="Finish"
      >
        <Question
          route="/get-started/onboarding"
          component={ManualOnboardingAddress}
          name="manualAddress"
        />
        <Question
          route="/get-started/onboarding/where-in-your-home-move"
          component={CustomerIntent}
          name="customerIntent"
        />
        <Question
          route="/get-started/onboarding/email"
          component={ManualOnboardingEmail}
          name="email"
        />
        <Question
          route="/get-started/onboarding/name"
          component={Name}
          name="name"
        />
        <Question
          route="/get-started/onboarding/phone-number"
          component={PhoneNumber}
          name="phone"
        />
        <Question
          key="sources"
          route="/get-started/onboarding/finishing-up"
          component={(props) => <Source {...props} includeBackButton />}
          includeBackButton
          name="sources"
        />
      </MultiStageForm>
    </>
  );
};
